import { render } from "./PassengerInfoDetail.vue?vue&type=template&id=790c4cc6&scoped=true&lang=pug"
import script from "./PassengerInfoDetail.vue?vue&type=script&lang=ts"
export * from "./PassengerInfoDetail.vue?vue&type=script&lang=ts"

import "./PassengerInfoDetail.vue?vue&type=style&index=0&id=790c4cc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-790c4cc6"

export default script